import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	COURSE_OF_STUDY_FEATURE_KEY,
	CourseOfStudyState,
	CourseOfStudyPartialState,
	courseofstudyAdapter
} from './courseofstudy.reducer';

// Lookup the 'CourseOfStudy' feature state managed by NgRx
export const getCourseOfStudyState = createFeatureSelector<CourseOfStudyPartialState, CourseOfStudyState>(
	COURSE_OF_STUDY_FEATURE_KEY
);

const { selectAll, selectEntities } = courseofstudyAdapter.getSelectors();

export const getCourseOfStudyLoaded = createSelector(
	getCourseOfStudyState,
	(state: CourseOfStudyState) => state.loaded
);

export const getCourseOfStudyError = createSelector(getCourseOfStudyState, (state: CourseOfStudyState) => state.error);

export const loadingCourseOfStudy = createSelector(getCourseOfStudyState, (state: CourseOfStudyState) => state.loaded);

export const getAllCourseOfStudy = createSelector(getCourseOfStudyState, (state: CourseOfStudyState) =>
	selectAll(state)
);

export const getCourseOfStudyEntities = createSelector(getCourseOfStudyState, (state: CourseOfStudyState) =>
	selectEntities(state)
);

export const getSelectedId = createSelector(
	getCourseOfStudyState,
	(state: CourseOfStudyState) => state.selectedCourseOfStudyId
);

export const getSelected = createSelector(
	getCourseOfStudyEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
